import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material'
import React from 'react'

const Conjunctiva = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Conjunctiva</InputLabel>
      <Select
        value={moduleValues?.[`Conjunctiva (${side})`] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [`Conjunctiva (${side})`]: e.target.value,
          }))
        }
        label="Conjunctiva"
      >
        {['Red', 'Pale', 'Chemosis', 'Normal'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default Conjunctiva
